import 'angular';
import * as $ from 'jquery';
import * as _ from 'lodash-es';
import {RootScope} from '../types/angular-types';

angular.module('GorillaBoy.directives')
.directive('hideHeaderNav', ['$rootScope', '$timeout', 'SignalProvider', ($rootScope, $timeout, SignalProvider) => {
    return {
        restrict: 'A',
        scope: true,
        link: ($scope, $element) => {
            $scope.$on(SignalProvider.Scroll.Up, (evt: MouseEvent) => {
                $($element).slideDown("slow", function() {
                    console.log('slide down');
                    // callback
                });
                
            });
            $scope.$on(SignalProvider.Scroll.Down, (evt: MouseEvent) => {
                $($element).slideUp("slow", function() {
                    // callback
                    console.log('slide up');
                });
            });
        }
    };
}])
.directive('hideHeaderContentContainer', ['$rootScope', '$timeout', 'SignalProvider', ($rootScope, $timeout, SignalProvider) => {
    /*
    CAUTION: Do not use this directive!!!
    This directive will "grab" the focus sometimes and disable scroll on file list. Do not use until the solution has been found
    for this bug.
    */
    return {
        restrict: 'A',
        scope: true,
        link: ($scope, $element) => {
            $scope.$on(SignalProvider.Scroll.Up, (evt: MouseEvent) => {
                $($element).css("height", "");
            });
            
            $scope.$on(SignalProvider.Scroll.Down, (evt: MouseEvent) => {
                $($element).css("height", "100%");
            });
            
        }
    };
}])
.directive('hideHeaderScrollTrigger', ['$rootScope', 'SignalProvider', ($rootScope: RootScope, SignalProvider) => {
    return {
        scope: true,
        link: ($scope, $element) => {
            var lastScrollTop = $element.scrollTop();
            $element.on('scroll', (evt: MouseEvent) => {
                var st = $element.scrollTop();
                // need to rebounce
                if (st > lastScrollTop){
                    console.log(st);
                    broadcastScrollDownSignal();
                } else if (st < lastScrollTop) {
                    console.log(st);
                    broadcastScrollUpSignal();
                }
                lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
            });

            var broadcastScrollUpSignal = _.debounce(function() {
                    $rootScope.$broadcast(SignalProvider.Scroll.Up);
                }, 300);

            var broadcastScrollDownSignal = _.debounce(function() {
                    $rootScope.$broadcast(SignalProvider.Scroll.Down);
                }, 300);
        }
    };
}]);
